export const MOODY_RATINGS = [
  "Aaa",
  "Aa1",
  "Aa2",
  "Aa3",
  "A1",
  "A2",
  "A3",
  "Baa1",
  "Baa2",
  "Baa3",
  "Ba1",
  "Ba2",
  "Ba3",
  "B1",
  "B2",
  "B3",
  "Caa1",
  "Caa2",
  "Caa3",
  "Ca1",
  "Ca2",
  "Ca3",
  "C1",
  "C2",
  "C3",
  "D",
] as const;

export type MoodysRating = typeof MOODY_RATINGS[number];

export const SP_RATINGS = [
  "AAA",
  "AA+",
  "AA",
  "AA-",
  "A+",
  "A",
  "A-",
  "BBB+",
  "BBB",
  "BBB-",
  "BB+",
  "BB",
  "BB-",
  "B+",
  "B",
  "B-",
  "CCC+",
  "CCC",
  "CCC-",
  "CC+",
  "CC",
  "CC-",
  "C+",
  "C",
  "C-",
  "D",
] as const;

export type SpRating = typeof SP_RATINGS[number];

export const MOODY_AND_SP_RATINGS = [
  ["AAA", "AAA"],
  ["Aa1", "AA+"],
  ["Aa2", "AA"],
  ["Aa3", "AA-"],
  ["A1", "A+"],
  ["A2", "A"],
  ["A3", "A-"],
  ["Baa1", "BBB+"],
  ["Baa2", "BBB"],
  ["Baa3", "BBB-"],
  ["Ba1", "BB+"],
  ["Ba2", "BB"],
  ["Ba3", "BB-"],
  ["B1", "B+"],
  ["B2", "B"],
  ["B3", "B-"],
  ["Caa1", "CCC+"],
  ["Caa2", "CCC"],
  ["Caa3", "CCC-"],
  ["Ca1", "CC+"],
  ["Ca2", "CC"],
  ["Ca3", "CC-"],
  ["C1", "C+"],
  ["C2", "C"],
  ["C3", "C-"],
  ["D", "D"],
] as const;

export const RATINGS_REVERSED_LIST = {
  moodys: [...MOODY_RATINGS].reverse(),
  sAndP: [...SP_RATINGS].reverse(),
  moodysOrSandP: [...MOODY_AND_SP_RATINGS].reverse(),
};

if (MOODY_RATINGS.length !== SP_RATINGS.length) {
  throw new Error("MOODY_RATINGS and SP_RATINGS must be same size");
}

if (SP_RATINGS.length !== MOODY_AND_SP_RATINGS.length) {
  throw new Error("SP_RATINGS and MOODY_AND_SP_RATINGS must be same size");
}

const createRatingsComparator = (referenceArray: readonly string[]) => (a: string, b: string) =>
  referenceArray.indexOf(a) - referenceArray.indexOf(b);

export const moodysRatingComparator = createRatingsComparator(MOODY_RATINGS);
export const spRatingComparator = createRatingsComparator(SP_RATINGS);
